import { BRANCHES } from '../../Research'

export const ResearchTreeBranchBar = ({
	branch,
	setBranch
	}: {
		branch: BRANCHES
		setBranch: (branch: BRANCHES) => void
	}) => {
	return (
		<div className="research-tree-branch-bar">
			<img 
				className={`research-tree-branch-bar-item ${branch === 'GERMAN' ? 'active' : ''}`} 
				src="/icons/flags/german.png" 
				alt="Germany" 
				onClick={() => setBranch('GERMAN')}
			/>
			<img 
				className={`research-tree-branch-bar-item ${branch === 'JAPANESE' ? 'active' : ''}`} 
				src="/icons/flags/japanese.png" 
				alt="Japan" 
				onClick={() => setBranch('JAPANESE')}
			/>
			<img 
				className={`research-tree-branch-bar-item ${branch === 'SOVIET' ? 'active' : ''}`} 
				src="/icons/flags/soviet.png" 
				alt="USSR" 
				onClick={() => setBranch('SOVIET')}
			/>
		</div>
	)
}